import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BeVeiculo } from 'src/app/models/BeVeiculo';
import { ActivatedRoute, Router } from '@angular/router';
import { SubService } from 'src/app/services/sub.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';

@Component({
  selector: 'app-create-veiculo',
  templateUrl: './create-veiculo.component.html',
  styleUrls: ['./create-veiculo.component.css']
})
export class CreateVeiculoComponent implements OnInit, OnDestroy {
  public subscription?: Subscription;
  public createFormGroup: FormGroup;

  private createIdVeiculoFormControl = new FormControl<number | null>(null);
  private createDsMarcaFormControl = new FormControl<string>("", [Validators.required, Validators.minLength(2), Validators.maxLength(20)]);
  private createDsModeloFormControl = new FormControl<string>("", [Validators.required, Validators.minLength(2), Validators.maxLength(20)]);
  private createDsCorFormControl = new FormControl<string>("", [Validators.required, Validators.minLength(3), Validators.maxLength(20)]);
  private createDsAnoFabricacaoFormControl = new FormControl<string>("", [Validators.required, Validators.minLength(4), Validators.maxLength(4)]);
  private createDsAnoModeloFormControl = new FormControl<string>("", [Validators.required, Validators.minLength(4), Validators.maxLength(4)]);
  private createDsPlacaFormControl = new FormControl<string>("", [Validators.required, Validators.minLength(7), Validators.maxLength(7),
                                                                  Validators.pattern(/^[A-Za-z]{3}[0-9]{1}[A-Za-z0-9]{1}[0-9]{2}$/)]);

  public constructor(
    private httpClient: HttpClient,
    private sub: SubService,
    private router: Router,
    private route: ActivatedRoute,
    private snackBarService: SnackBarService
  ) {
    this.createFormGroup = new FormGroup({
      idVeiculo: this.createIdVeiculoFormControl,
      dsModelo: this.createDsModeloFormControl,
      dsMarca: this.createDsMarcaFormControl,
      dsCor: this.createDsCorFormControl,
      dsAnoFabricacao: this.createDsAnoFabricacaoFormControl,
      dsAnoModelo: this.createDsAnoModeloFormControl,
      dsPlaca: this.createDsPlacaFormControl,
    });
  }

  public ngOnInit(): void {
    this.sub.clear();
    this.createIdVeiculoFormControl.setValue(null);
    this.createDsModeloFormControl.setValue(null);
    this.createDsMarcaFormControl.setValue(null);
    this.createDsCorFormControl.setValue(null);
    this.createDsAnoFabricacaoFormControl.setValue(null);
    this.createDsAnoModeloFormControl.setValue(null);
    this.createDsPlacaFormControl.setValue(null);
    this.unsubscribe();
  }

  public ngOnDestroy(): void {
    this.sub.clear();
    this.unsubscribe();
  }

  public onSalvar() {
    this.unsubscribe();
    this.subscription = this.httpClient.post<BeVeiculo>(
      `/api/Veiculos`, this.createFormGroup.value
    ).subscribe({
      next: () => {
        this.unsubscribe();
        this.snackBarService.exibirSucesso('Registro criado!');
        this.router.navigate(['/veiculos'], { relativeTo: this.route });
      },
      error: (err) => {
        this.unsubscribe();
        this.snackBarService.exibirErro(`Erro! - ${err.status} - ${err.statusText}`);
      }
    });
  }

  private unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = undefined;
    }
  }
}